<template>
    <InputDropdownCheckboxes
        translationkey="general.choose-stationroles"
        v-model="filteredRoles"
        :data="stationRoles"
        :hasSelectAllCheckbox="true"
        :icon="featureIcons.STATIONROLES"
    />
</template>
<script setup lang="ts">
import { InputDropdownCheckboxes } from '@/components';
import { featureIcons } from '@/components/Menu/featureicons';
import { useEventCommonStore } from '@/stores';
import { computed } from 'vue';

const props = defineProps<{
    /**
     * The raceID to filter the station roles by
     */
    raceID?: number | null;
}>();

const filteredRoles = defineModel<number[]>({
    required: true,
});

const commonStore = useEventCommonStore();

// Selectable station roles
const stationRoles = computed(() => {
    const stationRoleIDs = commonStore.StationRoles.filter(
        (role) => !props.raceID || role.RaceID == props.raceID || role.RaceID == null,
    ).map((role) => role.ID);
    return Array.from(commonStore.StationRolesAsSelectLine.values()).filter((selectLine) =>
        stationRoleIDs.includes(selectLine.value as number),
    );
});
</script>
